import { useEffect } from 'react';
import { useUIStore } from '@/stores/uiStore';
import { TopBar } from './TopBar';
import { HeroBanner } from './HeroBanner';
import { Footer } from './Footer';
import { Section01Measures } from './sections/Section01Measures';
import { Section02Shape } from './sections/Section02Shape';
import { Section03Options } from './sections/Section03Options';
import { Section04Recap } from './sections/Section04Recap';
import { Section05Client } from './sections/Section05Client';

function Toast() {
  const toast = useUIStore((s) => s.toast);
  const clearToast = useUIStore((s) => s.clearToast);
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(clearToast, 3000);
    return () => clearTimeout(t);
  }, [toast, clearToast]);
  if (!toast) return null;
  return (
    <div
      role="status"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-slate-900 text-white px-4 py-3 rounded-xl shadow-lg text-sm max-w-sm z-50"
    >
      {toast}
    </div>
  );
}

export function SingleViewLayout() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--canvas,#F5F7FA)' }}>
      <div className="max-w-[480px] sm:max-w-[640px] md:max-w-[800px] lg:max-w-[960px] xl:max-w-[1080px] w-full mx-auto bg-white shadow-xl flex-1 flex flex-col">
        <TopBar />
        <HeroBanner />
        <main className="p-4 flex-1" style={{ background: 'var(--canvas,#F5F7FA)' }}>
          <div className="md:grid md:grid-cols-2 md:gap-3 lg:grid-cols-3">
            <div className="md:col-span-1">
              <Section01Measures />
            </div>
            <div className="md:col-span-1">
              <Section02Shape />
            </div>
            <div className="md:col-span-1">
              <Section03Options />
            </div>
            <div className="md:col-span-2 lg:col-span-3">
              <Section04Recap />
            </div>
            <div className="md:col-span-2 lg:col-span-3">
              <Section05Client />
            </div>
          </div>
        </main>
        <Footer />
        <Toast />
      </div>
    </div>
  );
}
